<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
    <tracking-progress :transDataSet="transDate"></tracking-progress>
      <div class="container withProgress">
        <div class="area_wrap">
          <div class="doctor_wrap" v-for="d in getDoctorList" :key="d.id">
            <div class="dw_info">
              <div class="profile_wrap">
                <div class="info">
                  <div class="dw_imgWrap" @click="choiceDoctor(d.id, d.name, d.photoUrl)">
                    <img :src="'https://api.thanq.kr' + d.photoUrl">
                  </div>
                  <div class="profile_info">
                    <div class="imgWrap">
                      <img src="@/assets/images/logo_t.png">
                    </div>
                    <div class="dw_title" @click="choiceDoctor(d.id, d.name, d.photoUrl)">
                      <p>{{d.name}}</p>
                    </div>
                    <div class="dw_detail">
                      <p>{{d.specialtyMajor}} {{d.specialtySubject}} 전문의</p>
                      <p>{{d.job}}</p>
                    </div>
                    <div class="dw_btn">
                      <button type="button" @click="choiceDoctor(d.id, d.name, d.photoUrl)">의료진 선택</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dw_profile">
                <BaseAccordion :basic="basic">
                  <template v-slot:title>
                    <div class="detail">
                      <p>열어서 보기</p>
                      <div class="imgWrap">
                        <img src="@/assets/images/arrow.svg">
                      </div>
                    </div>
                  </template>

                  <template v-slot:content>
                    <div class="accordion">
                      <div class="accordion_title">
                        <h3>진료 가능한 수술/시술</h3>
                      </div>
                      <div class="accordion_content" v-for="s in d.surgery_list" :key="s.id + 'A'">
                        <p>
                        <span class="check_img">
                          <img src="@/assets/images/red_ck.svg">
                        </span>{{s.content}}
                        </p>
                      </div>
                      <div class="accordion_content" v-for="c in d.checkup_list" :key="c.id">
                        <p>
                        <span class="check_img">
                          <img src="@/assets/images/red_ck.svg">
                        </span>{{c.content}}
                        </p>
                      </div>
                    </div>
                  </template>
                </BaseAccordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import TrackingProgress from '../../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import BaseAccordion from '@/components/BaseAccordion'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      basic: {
        isShow: false,
        isOpen: false
      },
      plusStyle: {
        height: '330px'
      },
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        cancelBtnText: '취소',
        count: 'actionBtn',
        nextLink: '/reservation/selectDisease',
        closeType: 'close'
      },
      transDate: {
        headerName: '의료진 선택',
        progressNum: '75%',
        chapterNum: 3,
        prevUrl: '/reservation/selectDisease'
      },
      form: {
        comingReasonCategory: {
          value: '',
          flag: false,
          hasError: false
        },
        comingReasonCode: {
          value: '',
          flag: false,
          hasError: false
        },
        doctorInfo: {
          value: [],
          open: false
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getComing',
      'getDoctorList'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_DOCTOR',
      'SET_PRE_REASERVATION'
    ]),
    ...mapActions([
      'FETCH_DOCTOR_LIST'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/reservation/selectDisease')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    protection () {
      if (this.getComing.comingReasonCategory === '') {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '예약이 취소되었습니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/reservation/selectDisease'
        this.popupSet.nextLink = '/reservation/selectDisease'
      } else {
        this.verification()
        this.fetchData()
      }
    },
    verification () {
      console.log('내원사유에서 세팅한 정보 불러오기', this.getComing)
    },
    choiceDoctor (order, name, img) {
      const preReservationData = {
        comingReasonCategory: this.getComing.comingReasonCategory,
        comingReasonCode: this.getComing.comingReasonCode,
        visitPathCode: this.getComing.visitPathCode,
        etc: this.getComing.etc,
        etcReason: this.getComing.etcReason,
        etcContents: this.getComing.etcContents,
        doctorCode: order,
        doctorName: name,
        doctorImg: img
      }
      this.$store.commit('SET_PRE_REASERVATION', preReservationData)
      this.$router.push('/reservation/selectDate')
    },
    carryData () {
      if (this.getDoctorList.length < 1) {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '의료진 세팅이 되지 않았습니다. 관리자에게 문의하세요'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/reservation/selectDisease'
        this.popupSet.nextLink = '/reservation/selectDisease'
      } else {
        this.startPop()
        this.form.doctorInfo.value = this.getDoctorList
      }
    },
    toggleEvent () {
      const areaArr = document.querySelectorAll('.doctor_wrap')

      areaArr.forEach((area) => {
        const content = area.querySelector('.accordion_menu')
        const btn = area.querySelector('.detail')
        const arrow = btn.querySelector('.imgWrap')

        btn.addEventListener('click', () => {
          /* 한개 열리면 다른건 접히도록 */
          // if (content.classList.contains('show')) {
          //   areaArr.forEach((el) => {
          //     el.childNodes[1].classList.remove('show')
          //   })
          // }
          arrow.classList.toggle('rotate')
          content.classList.toggle('show')
          return false
        })
        return false
      })
      return false
    },
    startPop () {
      // [갑상선암 수술], [갑상선결절 시술] 선택 시 멘트
      console.log('this.getComing.content: ', this.getComing.content)
      if (this.getComing.content.indexOf('갑상선암') >= 0 || this.getComing.content.indexOf('갑상선결절') >= 0) {
        this.popupSet.content = '<p>상기 리스트는 선택하신 내원 사유에\n' +
          '가장 적합한 의료진(원장)을 표시합니다.</p>' +
          '<p class="mb-20">외래 진료 (검사나 수술 상담) 후 ' +
          '수술할 의사를 변경하고자 할 경우에는 ' +
          '나중에 변경할 수 있습니다.</p>' +
          '<p>* 빠른 수술일정을 원하실 때, 원하는 예약 일정에 예약할 수 없을 때는</p>' +
          '<p>전화로 예약하거나 전화예약상담 신청을 이용하시기 바랍니다.</p>'
        this.popupSet.longHeight = true
      } else if (this.getComing.content.indexOf('구강암') >= 0 ||
        this.getComing.content.indexOf('후두암') >= 0 ||
        this.getComing.content.indexOf('침샘암') >= 0 ||
        this.getComing.content.indexOf('기타 두경부암') >= 0) {
        // [구강암], [후두암], [침샘암], [기타 두경부암 수술] 선택 시 멘트
        this.popupSet.content = '<p>상기 리스트는 선택하신 내원 사유에\n' +
          '가장 적합한 의료진(원장)을 표시합니다.</p>' +
          '<p class="mb-20">외래 진료 (검사나 수술 상담) 후 ' +
          '수술할 의사를 변경하고자 할 경우에는 ' +
          '나중에 변경할 수 있습니다.</p>' +
          '<p>* 두경부암(구강암, 후두암, 침샘암 등) ' +
          '진단을 받으신 분은 하루라도 빠른 ' +
          '진료가 필요하기 때문에, 원하는 예약' +
          '일정에 예약할 수 없을 때는 ' +
          '전화로 예약하거나 전화예약상담 신청을 ' +
          '이용하시기 바랍니다.</p>'
        this.popupSet.longHeight = true
      } else {
        this.popupSet.content = '<p>상기 리스트는 선택하신 내원 사유에\n' +
          '가장 적합한 의료진(원장)을 표시합니다.</p>' +
          '<p class="mb-20">외래 진료 (검사나 수술 상담) 후 ' +
          '수술할 의사를 변경하고자 할 경우에는 ' +
          '나중에 변경할 수 있습니다.</p>'
        this.popupSet.longHeight = false
      }
      this.popupSet.topImg = true
      this.popupSet.cancelBtnText = '뒤로가기'
      this.popupSet.confirmBtnText = '계속진행하기'
      this.SET_POPUP(true)
    },
    async fetchData () {
      try {
        const reasonData = {
          comingReasonCategory: this.getComing.comingReasonCategory,
          comingReasonCode: this.getComing.comingReasonCode,
          etc: this.getComing.etc,
          etcReason: this.getComing.etcReason
        }
        this.FETCH_DOCTOR_LIST(reasonData)
          .then(() => this.carryData())
      } catch (error) {
        console.log('error :', error);
        console.log('예약시 의료진 조회 api에서 에러발생.')
        if (error.status === 500) {
          this.SET_POPUP(true)
          this.popupSet.content = '서버 내부의 오류로 의료진 설정을 불러올 수 없습니다.'
        } else if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup,
    BaseAccordion
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.protection()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
